import React from "react";
import "../App.css";

function Styling() {
  return (
    <div className="App">
      <main>
        <section className="content-section">
          <h2>Headers</h2>
          <h1>Header 1</h1>
          <h2>Header 2</h2>
          <h3>Header 3</h3>
          <h4>Header 4</h4>
          <h5>Header 5</h5>
          <h6>Header 6</h6>
        </section>
        <section className="content-section">
          <h2>Text Elements</h2>
          <p>This is a paragraph of text styled with your chosen color scheme.</p>
          <strong>This is bold text.</strong>
          <br />
          <em>This is italic text.</em>
          <br />
          <a href="https://www.google.com" className="custom-link">
            This is a link
          </a>
        </section>
        <section className="content-section">
          <h2>Lists</h2>
          <ul>
            <li>Unordered List Item 1</li>
            <li>Unordered List Item 2</li>
          </ul>
          <ol>
            <li>Ordered List Item 1</li>
            <li>Ordered List Item 2</li>
          </ol>
        </section>
      </main>
    </div>
  );
}

export default Styling;
